import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Icon } from 'semantic-ui-react';

import { deleteWeatherItem } from '../actions/index';

class DeleteWeatherButton extends Component {
	handleButtonClick = item => {
		this.props.deleteWeatherItem(item);
	};

	render() {
		return (
			<span style={{ float: 'right' }}>
				<Icon
					onClick={this.handleButtonClick.bind(this, this.props.data)}
					link
					name="trash"
					color="red"
					style={{ opacity: '0.25' }}
				/>
			</span>
		);
	}
}

const mapDispatchToProps = dispatch =>
	bindActionCreators({ deleteWeatherItem }, dispatch);

export default connect(null, mapDispatchToProps)(DeleteWeatherButton);



// WEBPACK FOOTER //
// ./src/containers/DeleteWeatherButton.js